export default function directive($timeout) {
  "ngInject";
  return {
    restrict: 'A',
    link: function(scope, el, attrs) {
      $timeout(() => {
        el.not('.slick-initialized').slick(scope.$eval(attrs.slickSlider));
      });
    }
  };
}



// WEBPACK FOOTER //
// ./js/containers/causePortal/directives/slickSlider.js